import { Dropdown, Tooltip } from 'antd';
import { SettingOutlined } from '@ant-design/icons';
import styled from 'styled-components';

import ColumnConfigDropdown from './ColumnConfigDropdown';
import type { IColumnVisibilityState } from '../hooks/useColumnVisibility';
import { ColumnType } from 'antd/es/table';

interface IProps<T> {
  columns: ColumnType<T>[];
  visibilityState: IColumnVisibilityState;
  onVisibilityChange: (key: string, visible: boolean) => void;
}

const ConfigureColumnsButton = <T extends object>({
  columns,
  visibilityState,
  onVisibilityChange,
}: IProps<T>) => {
  const dropdownContent = (
    <ColumnConfigDropdown
      columns={columns}
      visibilityState={visibilityState}
      onVisibilityChange={onVisibilityChange}
    />
  );

  return (
    <Dropdown
      trigger={['click']}
      placement="bottomRight"
      popupRender={() => <DropdownWrapper>{dropdownContent}</DropdownWrapper>}
    >
      <Tooltip title="Configure columns" placement="topLeft">
        <SettingOutlined />
      </Tooltip>
    </Dropdown>
  );
};

const DropdownWrapper = styled.div`
  background: ${({ theme }) => theme.colors.surface};
  border-radius: ${({ theme }) => theme.borderRadius.lg};
  box-shadow: ${({ theme }) => theme.shadows.lg};
`;

export default ConfigureColumnsButton;
